<template>
  <div class="wrapper-page">
    <div class="card-box shadow-lg p-5" style="max-width: 450px; margin: 0 auto;">
      <div class="text-center mb-4">
        <a class="logo-lg d-block">
          <img src="@/assets/logo_roadme.png" style="max-height: 50px; width: auto;">
        </a>
        <h4 class="mt-3 font-weight-bold text-primary">Bentornato!</h4>
        <p class="text-muted">Accedi al tuo account per continuare</p>
      </div>

      <div class="alert alert-danger" v-if="loginError">
        <strong>Attenzione!</strong> Le credenziali immesse non sono valide.
      </div>

      <div class="mt-4">
        <div class="form-group mb-3">
          <label class="small font-weight-semibold text-muted text-uppercase mb-1">Username</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-light border-right-0">
                <i class="mdi mdi-account text-muted"></i>
              </span>
            </div>
            <input 
              class="form-control bg-light border-left-0" 
              type="text" 
              required 
              placeholder="Inserisci lo username" 
              v-model="username" 
              @keyup.enter="provideLogin()"
            />
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="small font-weight-semibold text-muted text-uppercase mb-1">Password</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-light border-right-0">
                <i class="mdi mdi-key text-muted"></i>
              </span>
            </div>
            <input 
              class="form-control bg-light border-left-0 border-right-0" 
              :type="showPassword ? 'text' : 'password'" 
              required 
              placeholder="Inserisci la password" 
              v-model="password" 
              @keyup.enter="provideLogin()"
            />
            <div class="input-group-append">
              <span class="input-group-text bg-light border-left-0" style="cursor: pointer;" @click="showPassword = !showPassword">
                <i :class="['mdi', showPassword ? 'mdi-eye-off' : 'mdi-eye', 'text-muted']"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="form-group mb-4 d-flex align-items-center justify-content-between">
          <div class="custom-control custom-checkbox">
            <input 
              type="checkbox" 
              class="custom-control-input" 
              id="rememberMe" 
              v-model="rememberMe"
            />
            <label class="custom-control-label text-muted small" for="rememberMe" style="cursor: pointer;">
              Ricordami
            </label>
          </div>
        </div>

        <div class="form-group mb-0">
          <button
            class="btn btn-primary btn-block py-2 font-weight-bold shadow-md"
            @click="provideLogin()"
          >Accedi</button>
        </div>
      </div>
    </div>
    
    <div class="text-center mt-5 text-muted small">
      <i class="mdi mdi-road mr-1"></i>
      <strong>roadME</strong> &copy; Campania Sistemi srl 2025
    </div>
  </div>
</template>

<script>
export default {

  data(){
    return {
      username: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      loginError: false
    }
  },

  mounted() {
    const savedUsername = localStorage.getItem('remembered_username');
    if (savedUsername) {
      this.username = savedUsername;
      this.rememberMe = true;
    }
  },

  methods: {
    provideLogin () {
      var jsonBody = {
        username: this.username,
        password: this.password
      }
      this.axios.post(`login`, jsonBody).then(response=>{
        if(response.data['success']){
          if (this.rememberMe) {
            localStorage.setItem('remembered_username', this.username);
          } else {
            localStorage.removeItem('remembered_username');
          }
          localStorage.setItem('token', response.data['auth_token']);
          localStorage.setItem('tipologia', response.data['tipologia']);
          localStorage.setItem('fk_company', response.data['fk_company'] || '');
          this.$router.push({name: 'home'})
        } else {
          this.loginError = true;
        }
      },
      error => {
        console.log(error);
        this.loginError = true;
      })
    }
  }
};
</script>

<style>
</style>